const getLoadingStatus = state => state.types.isLoading;

const getTypes = state => state.types.types;

export { getLoadingStatus, getTypes };
